import React, { useContext } from 'react'
import { Formik } from 'formik';
import * as yup from "yup";
import { Box, Button, Dialog, DialogContent, TextField, Typography } from '@mui/material';
import axios from 'axios';
import { AdminContext } from '../../../../context/AdminContext';
import { tokens } from '../../../../theme';

function ReadingExamCategoryDialog({ targetCategory, dialogOpen, handleClose }) {
    const { token } = useContext(AdminContext);

    var initialValues = {
        title: targetCategory?.title ? targetCategory?.title : "",
        description: targetCategory?.description ? targetCategory?.description : "",
        translations: targetCategory?.translations ? targetCategory.translations : [{
            title_translation: "",
            description_translation: "",
            language: "turkish"
        },
        {
            title_translation: "",
            description_translation: "",
            language: "german"
        },
        {
            title_translation: "",
            description_translation: "",
            language: "spanish"
        },
        {
            title_translation: "",
            description_translation: "",
            language: "french"
        },
        {
            title_translation: "",
            description_translation: "",
            language: "portuguese"
        },
        {
            title_translation: "",
            description_translation: "",
            language: "italian"
        }],
    }

    var validationObject = {
        title: yup.string().required("required"),
        description: yup.string().required("required"),
        translations: yup.array().of(
            yup.object({
                title_translation: yup.string().required("required"),
                description_translation: yup.string().required("required"),
                language: yup.string().required("required")
            }).required("required")
        ).required("required")
    }

    const categorySchema = yup.object().shape(validationObject);

    const handleFormSubmit = async (values) => {
        if (!targetCategory) {
            await axios.post(`${process.env.REACT_APP_API_URL}reading/createReadingExamCategoryWithTranslations?token=${token}`, {
                ...values
            }).catch((err) => {
                console.log("err: " + err);
            }).then((response) => {
                if (response && response.data.success === true && response.data.status === 201) {
                    handleClose(true)
                }
            });
        } else {
            await axios.patch(`${process.env.REACT_APP_API_URL}reading/updateReadingExamCategoryWithTranslations?categoryId=${targetCategory.id}&token=${token}`, {
                ...values
            }).catch((err) => {
                console.log("err: " + err);
            }).then((response) => {
                if (response && response.data.success === true && response.data.status === 201) {
                    handleClose(true)
                }
            });
        }

    }

    const performTranslate = (wordToTranslate, languageSymbol, cb) => {
        axios.patch(`${process.env.REACT_APP_API_URL}translateWithBing`, {
            sentence: wordToTranslate,
            languageSymbol: languageSymbol
        }).catch((err) => {
            console.log("err", err);
        }).then((response) => {
            console.log(wordToTranslate, languageSymbol, response.data.translation);
            if (response && response.data.success === true && response.data.status === 200) {
                cb(response.data.translation);
            } else {
                cb("-");
            }
        })

    }

    const translateCategory = (title, description, translations, setFieldValue) => {
        performTranslate(title, "tr", (translation) => {
            var ix = translations.findIndex((t) => t.language === "turkish");
            setFieldValue(`translations[${ix}].title_translation`, translation)
        });
        performTranslate(title, "de", (translation) => {
            var ix = translations.findIndex((t) => t.language === "german");
            setFieldValue(`translations[${ix}].title_translation`, translation)
        });
        performTranslate(title, "es", (translation) => {
            var ix = translations.findIndex((t) => t.language === "spanish");
            setFieldValue(`translations[${ix}].title_translation`, translation)
        });
        performTranslate(title, "fr", (translation) => {
            var ix = translations.findIndex((t) => t.language === "french");
            setFieldValue(`translations[${ix}].title_translation`, translation)
        });
        performTranslate(title, "pt-PT", (translation) => {
            var ix = translations.findIndex((t) => t.language === "portuguese");
            setFieldValue(`translations[${ix}].title_translation`, translation)
        });
        performTranslate(title, "it", (translation) => {
            var ix = translations.findIndex((t) => t.language === "italian");
            setFieldValue(`translations[${ix}].title_translation`, translation)
        });
        performTranslate(description, "tr", (translation) => {
            var ix = translations.findIndex((t) => t.language === "turkish");
            setFieldValue(`translations[${ix}].description_translation`, translation)
        });
        performTranslate(description, "de", (translation) => {
            var ix = translations.findIndex((t) => t.language === "german");
            setFieldValue(`translations[${ix}].description_translation`, translation)
        });
        performTranslate(description, "es", (translation) => {
            var ix = translations.findIndex((t) => t.language === "spanish");
            setFieldValue(`translations[${ix}].description_translation`, translation)
        });
        performTranslate(description, "fr", (translation) => {
            var ix = translations.findIndex((t) => t.language === "french");
            setFieldValue(`translations[${ix}].description_translation`, translation)
        });
        performTranslate(description, "pt-PT", (translation) => {
            var ix = translations.findIndex((t) => t.language === "portuguese");
            setFieldValue(`translations[${ix}].description_translation`, translation)
        });
        performTranslate(description, "it", (translation) => {
            var ix = translations.findIndex((t) => t.language === "italian");
            setFieldValue(`translations[${ix}].description_translation`, translation)
        });
    }

    return (
        <Dialog
            sx={{ margin: "0 auto" }} open={dialogOpen}
            onClose={() => handleClose(false)}>
            <Box mx="20px" mt="20px" textAlign="center">
                {targetCategory &&
                    <Typography variant='h3'>
                        Edit Category ({targetCategory?.title})
                    </Typography>
                }
                {!targetCategory &&
                    <Typography variant='h3'>
                        New Category
                    </Typography>
                }
            </Box>
            <DialogContent>
                <Box>
                    <Formik
                        onSubmit={handleFormSubmit}
                        initialValues={initialValues}
                        validationSchema={categorySchema}
                    >
                        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
                            <form onSubmit={handleSubmit}>
                                <Box display="grid" gap="15px" gridTemplateColumns="repeat(6, minmax(0, 1fr))" mx="75px" mb="25px">
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Title"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        name={"title"}
                                        value={values.title}
                                        error={!!touched.title && !!errors.title}
                                        helperText={touched.title && errors.title}
                                        sx={{ gridColumn: "span 6", marginTop: "20px" }}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Description"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        name={"description"}
                                        value={values.description}
                                        error={!!touched.description && !!errors.description}
                                        helperText={touched.description && errors.description}
                                        sx={{ gridColumn: "span 6", marginTop: "20px" }}
                                    />

                                    <Button color="success" variant="contained" sx={{ gridColumn: "3 / span 2", marginTop: "20px" }} onClick={() => translateCategory(values.title, values.description, values.translations, setFieldValue)}>
                                        <Typography>Translate</Typography>
                                    </Button>

                                    {values.translations.map((translation, j) =>
                                        <Box key={`translations-${j}`} display="grid" gap="15px" gridTemplateColumns="repeat(6, minmax(0, 1fr))" gridColumn={"span 6"}>
                                            <TextField
                                                key={`title-translation-${j}`}
                                                variant="filled"
                                                type="text"
                                                label={`Title(${translation.language})`}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name={"translations[" + j + "].title_translation"}
                                                value={values.translations[j].title_translation}
                                                error={!!touched?.translations && !!touched?.translations[j]?.title_translation && !!errors?.translations && !!errors?.translations[j]?.title_translation}
                                                helperText={touched?.translations && touched?.translations[j]?.title_translation && errors?.translations && errors?.translations[j]?.title_translation}
                                                sx={{ gridColumn: "span 3" }}
                                            />
                                            <TextField
                                                key={`decription-translation-${j}`}
                                                variant="filled"
                                                type="text"
                                                label={`Description(${translation.language})`}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                name={"translations[" + j + "].description_translation"}
                                                value={values.translations[j].description_translation}
                                                error={!!touched?.translations && !!touched?.translations[j]?.description_translation && !!errors?.translations && !!errors?.translations[j]?.description_translation}
                                                helperText={touched?.translations && touched?.translations[j]?.description_translation && errors?.translations && errors?.translations[j]?.description_translation}
                                                sx={{ gridColumn: "span 3" }}
                                            />
                                        </Box>
                                    )}
                                </Box>
                                <Box display="flex" justifyContent="end" m="20px 20px 0px 20px">
                                    <Button type="submit" color="secondary" variant="contained">
                                        <Typography variant='h5'>Save</Typography>
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default ReadingExamCategoryDialog